import type { Variants } from 'framer-motion';

const STAGGER_CHILDREN_SECONDS = 0.1;
const STAGGER_DELAY_CHILDREN_SECONDS = 0.05;
const ITEM_ENTER_DISTANCE_PX = 14;
const ITEM_ENTER_DURATION_SECONDS = 0.3;

/** Staggered fade-in for a page-level container; pairs with `itemVariants` on its children. */
export const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: STAGGER_CHILDREN_SECONDS, delayChildren: STAGGER_DELAY_CHILDREN_SECONDS },
  },
};

export const itemVariants: Variants = {
  hidden: { opacity: 0, y: ITEM_ENTER_DISTANCE_PX },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: ITEM_ENTER_DURATION_SECONDS, ease: 'easeOut' },
  },
};
